import { useFilterPanel } from './FilterPanelContext'

interface Props {
    name: string
    label: string
    placeholder?: string
}

export const FilterInput = ({ name, label, placeholder }: Props) => {
    const { values, setValue, clearValue } = useFilterPanel()
    const value = (values[name] as string) ?? ''

    return (
        <div>
            <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-800">{label}</span>
                {value && (
                    <button
                        type="button"
                        onClick={() => clearValue(name)}
                        className="text-sm font-semibold text-green-600 hover:text-green-700"
                    >
                        Limpiar
                    </button>
                )}
            </div>
            <input
                type="text"
                value={value}
                onChange={(e) => setValue(name, e.target.value)}
                placeholder={placeholder}
                className="w-full px-3 h-11 rounded-lg border border-slate-300 bg-white text-sm text-gray-700 placeholder-gray-400 outline-none focus:ring-2 focus:ring-green-500"
            />
        </div>
    )
}
